import React from "react";

import  ReviewSection  from './reviewSection';

class ReviewSections extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: props.items //getStore().terms
        };        
      }      
    render() {
        return (
            <>
              {this.state.items.map(c => <ReviewSection splitPayment={this.props.splitPayment} id={c.id} key={c.id} item={c}/>)}
             </> 
          );
    }
}
export default ReviewSections;